import { WIDGET_TYPES } from '../../types'

export const inlineTemplates = [
  {
    idx: 0,
    type: 'INLINE_CAROUSEL',
    text: null,
    position: 'CENTER',
    deleted: false,
    name: 'Continuous',
    desktopVideos: 5,
    landscape: false,
    borderRadius: 0,
    playButtonColor: '#ffffff',
    marginY: 0,
    marginX: 0,
    fontWeight: '700',
    fontSize: 32,
    fontFamily: null,
    textAlign: null,
    titleColor: '#000000',
    playButtonAnimation: false,
    mobileScrollMethod: 'SWIPE',
    mobileFontSize: 32,
    border: true,
    borderColor: '#000000',
    durationDisplay: false,
    dimensions: 'LANDSCAPE',
    maxWidth: null,
    responsive: true,
    height: 300,
    defaultOpenFullscreen: false,
    mobileDimensions: 'FOLLOW',
    widgetTitleActive: true,
    widgetDesktopTitleFontSize: 28,
    widgetMobileTitleFontSize: 14,
    widgetTitleFontWeight: 700,
    widgetTitleFontColor: '#000000',
    widgetTitleFontFamily: null,
    widgetTitleAlignment: 'LEFT',
    widgetSubtitleFontWeight: 500,
    widgetTitlePosition: 'BELOW',
    widgetDesktopSubtitleFontSize: 18,
    widgetMobileSubtitleFontSize: 14,
    widgetAutoplay: true,
    widgetSubtitleFontFamily: null,
    widgetSubtitleFontColor: '#000000',
    widgetThumbnailDimensions: 'PORTRAIT',
    widgetGapWidth: 0,
    widgetArrowPosition: 'CENTER_BELOW',
    widgetMobileThumbnailDimensions: 'PORTRAIT',
    widgetMobileThumbnailSize: 'LARGE',
    widgetThumbnailBorder: false,
    widgetPlayButtonPosition: 'BOTTOM_LEFT',
    widgetThumbnailBorderColor: '#000000',
    widgetThumbnailBorderSize: 2,
    widgetButtonStyle: 'SQUARE_FUNK',
    widgetChevronPrimaryColor: '#000000',
    widgetChevronSecondaryColor: '#ffffff',
    widgetIsPartialStart: true,
    widgetPlayButtonStyle: 'LIGHT',
    widgetFixedThumbnail: false,
    widgetFixedThumbnailWidth: 200,
    widgetFixedThumbnailHeight: 300,
    widgetIsFixedCircle: false,
    widgetHideCompareAtPrice: false,
    widgetHideDesktop: false,
    mobileVideos: 2,
    widgetMobileChevrons: false,
    widgetNoMaxThumbnailWidth: false,
    widgetMaxThumbnailWidth: 400,
    widgetSearchBorderRadius: 'SOFT',
    widgetSearchUseName: true,
    widgetSearchThumbnailSize: 'MEDIUM',
    widgetSearchOverlayBackgroundColor: '#FFFFFF',
    widgetSearchShowSearchBar: true,
    widgetSearchSearchVideoNames: false,
    widgetSearchShowPopular: false,
    widgetSearchPopularText: 'Popular',
    widgetSearchPopularButtonColor: '#9F1F1F',
    widgetSearchPopularTextColor: '#FFFFFF',
    widgetSearchGridOffset: false,
    widgetSearchSearchableContent: 'VIDEOS',
    widgetShowProgressBar: true,
    widgetShareButton: true,
    widgetPlayButtonSize: 'SMALL'
  },
  {
    idx: 1,
    type: 'INLINE_CAROUSEL',
    text: null,
    position: 'CENTER',
    deleted: false,
    name: 'Elegant',
    desktopVideos: 5,
    landscape: false,
    borderRadius: 0,
    playButtonColor: '#333333',
    marginY: 0,
    marginX: 0,
    fontWeight: '700',
    fontSize: 32,
    fontFamily: null,
    textAlign: null,
    titleColor: '#000000',
    playButtonAnimation: true,
    mobileScrollMethod: 'SWIPE',
    mobileFontSize: 32,
    border: true,
    borderColor: '#000000',
    durationDisplay: false,
    dimensions: 'LANDSCAPE',
    maxWidth: null,
    responsive: true,
    height: 300,
    defaultOpenFullscreen: false,
    mobileDimensions: 'FOLLOW',
    widgetTitleActive: true,
    widgetDesktopTitleFontSize: 16,
    widgetMobileTitleFontSize: 14,
    widgetTitleFontWeight: 700,
    widgetTitleFontColor: '#000000',
    widgetTitleFontFamily: null,
    widgetTitleAlignment: 'LEFT',
    widgetSubtitleFontWeight: 500,
    widgetTitlePosition: 'BELOW',
    widgetDesktopSubtitleFontSize: 14,
    widgetMobileSubtitleFontSize: 14,
    widgetAutoplay: true,
    widgetSubtitleFontFamily: null,
    widgetSubtitleFontColor: '#939393',
    widgetThumbnailDimensions: 'SQUASHED_PORTRAIT',
    widgetGapWidth: 8,
    widgetArrowPosition: 'BELOW_LEFT',
    widgetMobileThumbnailDimensions: 'PORTRAIT',
    widgetMobileThumbnailSize: 'LARGE',
    widgetThumbnailBorder: false,
    widgetPlayButtonPosition: 'BOTTOM_RIGHT',
    widgetThumbnailBorderColor: '#000000',
    widgetThumbnailBorderSize: 2,
    widgetButtonStyle: 'NONE_ARROW',
    widgetChevronPrimaryColor: '#000000',
    widgetChevronSecondaryColor: '#ffffff',
    widgetIsPartialStart: false,
    widgetPlayButtonStyle: 'DURATION',
    widgetFixedThumbnail: false,
    widgetFixedThumbnailWidth: 200,
    widgetFixedThumbnailHeight: 300,
    widgetIsFixedCircle: false,
    widgetHideCompareAtPrice: false,
    widgetHideDesktop: false,
    mobileVideos: 2,
    widgetMobileChevrons: false,
    widgetNoMaxThumbnailWidth: false,
    widgetMaxThumbnailWidth: 400,
    widgetSearchBorderRadius: 'SOFT',
    widgetSearchUseName: true,
    widgetSearchThumbnailSize: 'MEDIUM',
    widgetSearchOverlayBackgroundColor: '#FFFFFF',
    widgetSearchShowSearchBar: true,
    widgetSearchSearchVideoNames: false,
    widgetSearchShowPopular: false,
    widgetSearchPopularText: 'Popular',
    widgetSearchPopularButtonColor: '#9F1F1F',
    widgetSearchPopularTextColor: '#FFFFFF',
    widgetSearchGridOffset: false,
    widgetSearchSearchableContent: 'VIDEOS',
    widgetShowProgressBar: true,
    widgetShareButton: true,
    widgetPlayButtonSize: 'SMALL'
  },
  {
    idx: 2,
    type: 'INLINE_CAROUSEL',
    text: null,
    position: 'CENTER',
    deleted: false,
    name: 'Bold',
    desktopVideos: 3,
    landscape: false,
    borderRadius: 24,
    playButtonColor: '#000000',
    marginY: 0,
    marginX: 0,
    fontWeight: '700',
    fontSize: 32,
    fontFamily: null,
    textAlign: null,
    titleColor: '#000000',
    playButtonAnimation: false,
    mobileScrollMethod: 'SWIPE',
    mobileFontSize: 32,
    border: true,
    borderColor: '#000000',
    durationDisplay: false,
    dimensions: 'LANDSCAPE',
    maxWidth: null,
    responsive: true,
    height: 300,
    defaultOpenFullscreen: false,
    mobileDimensions: 'FOLLOW',
    widgetTitleActive: true,
    widgetDesktopTitleFontSize: 32,
    widgetMobileTitleFontSize: 14,
    widgetTitleFontWeight: 900,
    widgetTitleFontColor: '#000000',
    widgetTitleFontFamily: null,
    widgetTitleAlignment: 'CENTER',
    widgetSubtitleFontWeight: 500,
    widgetTitlePosition: 'INSIDE',
    widgetDesktopSubtitleFontSize: 18,
    widgetMobileSubtitleFontSize: 14,
    widgetAutoplay: true,
    widgetSubtitleFontFamily: null,
    widgetSubtitleFontColor: '#000000',
    widgetThumbnailDimensions: 'PORTRAIT',
    widgetGapWidth: 32,
    widgetArrowPosition: 'OUTSIDE',
    widgetMobileThumbnailDimensions: 'PORTRAIT',
    widgetMobileThumbnailSize: 'LARGE',
    widgetThumbnailBorder: false,
    widgetPlayButtonPosition: 'CENTER',
    widgetThumbnailBorderColor: '#000000',
    widgetThumbnailBorderSize: 2,
    widgetButtonStyle: 'CIRCLE_ARROW',
    widgetChevronPrimaryColor: '#000000',
    widgetChevronSecondaryColor: '#ffffff',
    widgetIsPartialStart: false,
    widgetPlayButtonStyle: 'FILLED',
    widgetFixedThumbnail: false,
    widgetFixedThumbnailWidth: 200,
    widgetFixedThumbnailHeight: 300,
    widgetIsFixedCircle: false,
    widgetHideCompareAtPrice: false,
    widgetHideDesktop: false,
    mobileVideos: 2,
    widgetMobileChevrons: false,
    widgetNoMaxThumbnailWidth: false,
    widgetMaxThumbnailWidth: 400,
    widgetSearchBorderRadius: 'SOFT',
    widgetSearchUseName: true,
    widgetSearchThumbnailSize: 'MEDIUM',
    widgetSearchOverlayBackgroundColor: '#FFFFFF',
    widgetSearchShowSearchBar: true,
    widgetSearchSearchVideoNames: false,
    widgetSearchShowPopular: false,
    widgetSearchPopularText: 'Popular',
    widgetSearchPopularButtonColor: '#9F1F1F',
    widgetSearchPopularTextColor: '#FFFFFF',
    widgetSearchGridOffset: false,
    widgetSearchSearchableContent: 'VIDEOS',
    widgetShowProgressBar: true,
    widgetShareButton: true,
    widgetPlayButtonSize: 'LARGE'
  },
  {
    idx: 3,
    type: 'INLINE_CAROUSEL',
    text: null,
    position: 'CENTER',
    deleted: false,
    name: 'Simple',
    desktopVideos: 3,
    landscape: false,
    borderRadius: 32,
    playButtonColor: '#000000',
    marginY: 0,
    marginX: 0,
    fontWeight: '700',
    fontSize: 32,
    fontFamily: null,
    textAlign: null,
    titleColor: '#000000',
    playButtonAnimation: false,
    mobileScrollMethod: 'SWIPE',
    mobileFontSize: 32,
    border: true,
    borderColor: '#000000',
    durationDisplay: false,
    dimensions: 'LANDSCAPE',
    maxWidth: null,
    responsive: true,
    height: 300,
    defaultOpenFullscreen: false,
    mobileDimensions: 'FOLLOW',
    widgetTitleActive: true,
    widgetDesktopTitleFontSize: 24,
    widgetMobileTitleFontSize: 14,
    widgetTitleFontWeight: 700,
    widgetTitleFontColor: '#000000',
    widgetTitleFontFamily: null,
    widgetTitleAlignment: 'CENTER',
    widgetSubtitleFontWeight: 500,
    widgetTitlePosition: 'BELOW',
    widgetDesktopSubtitleFontSize: 16,
    widgetMobileSubtitleFontSize: 14,
    widgetAutoplay: true,
    widgetSubtitleFontFamily: null,
    widgetSubtitleFontColor: '#000000',
    widgetThumbnailDimensions: 'PORTRAIT',
    widgetGapWidth: 16,
    widgetArrowPosition: 'CENTER_BELOW',
    widgetMobileThumbnailDimensions: 'PORTRAIT',
    widgetMobileThumbnailSize: 'LARGE',
    widgetThumbnailBorder: false,
    widgetPlayButtonPosition: 'CENTER',
    widgetThumbnailBorderColor: '#000000',
    widgetThumbnailBorderSize: 2,
    widgetButtonStyle: 'CIRCLE_FUNK',
    widgetChevronPrimaryColor: '#ffffff',
    widgetChevronSecondaryColor: '#000000',
    widgetIsPartialStart: false,
    widgetPlayButtonStyle: 'BOX',
    widgetFixedThumbnail: false,
    widgetFixedThumbnailWidth: 200,
    widgetFixedThumbnailHeight: 300,
    widgetIsFixedCircle: false,
    widgetHideCompareAtPrice: false,
    widgetHideDesktop: false,
    mobileVideos: 2,
    widgetMobileChevrons: false,
    widgetNoMaxThumbnailWidth: false,
    widgetMaxThumbnailWidth: 400,
    widgetSearchBorderRadius: 'SOFT',
    widgetSearchUseName: true,
    widgetSearchThumbnailSize: 'MEDIUM',
    widgetSearchOverlayBackgroundColor: '#FFFFFF',
    widgetSearchShowSearchBar: true,
    widgetSearchSearchVideoNames: false,
    widgetSearchShowPopular: false,
    widgetSearchPopularText: 'Popular',
    widgetSearchPopularButtonColor: '#9F1F1F',
    widgetSearchPopularTextColor: '#FFFFFF',
    widgetSearchGridOffset: false,
    widgetSearchSearchableContent: 'VIDEOS',
    widgetShowProgressBar: true,
    widgetShareButton: true,
    widgetPlayButtonSize: 'LARGE'
  },
  {
    idx: 4,
    type: 'INLINE_CAROUSEL',
    text: null,
    position: 'CENTER',
    deleted: false,
    name: 'Landscape',
    desktopVideos: 3,
    landscape: false,
    borderRadius: 4,
    playButtonColor: '#000000',
    marginY: 0,
    marginX: 0,
    fontWeight: '700',
    fontSize: 32,
    fontFamily: null,
    textAlign: null,
    titleColor: '#000000',
    playButtonAnimation: false,
    mobileScrollMethod: 'SWIPE',
    mobileFontSize: 32,
    border: true,
    borderColor: '#000000',
    durationDisplay: false,
    dimensions: 'LANDSCAPE',
    maxWidth: null,
    responsive: true,
    height: 300,
    defaultOpenFullscreen: false,
    mobileDimensions: 'FOLLOW',
    widgetTitleActive: true,
    widgetDesktopTitleFontSize: 18,
    widgetMobileTitleFontSize: 14,
    widgetTitleFontWeight: 700,
    widgetTitleFontColor: '#000000',
    widgetTitleFontFamily: null,
    widgetTitleAlignment: 'LEFT',
    widgetSubtitleFontWeight: 500,
    widgetTitlePosition: 'BELOW',
    widgetDesktopSubtitleFontSize: 18,
    widgetMobileSubtitleFontSize: 14,
    widgetAutoplay: true,
    widgetSubtitleFontFamily: null,
    widgetSubtitleFontColor: '#000000',
    widgetThumbnailDimensions: 'LANDSCAPE',
    widgetGapWidth: 16,
    widgetArrowPosition: 'BELOW',
    widgetMobileThumbnailDimensions: 'PORTRAIT',
    widgetMobileThumbnailSize: 'LARGE',
    widgetThumbnailBorder: false,
    widgetPlayButtonPosition: 'CENTER',
    widgetThumbnailBorderColor: '#000000',
    widgetThumbnailBorderSize: 2,
    widgetButtonStyle: 'CIRCLE_ARROW',
    widgetChevronPrimaryColor: '#ffffff',
    widgetChevronSecondaryColor: '#000000',
    widgetIsPartialStart: false,
    widgetPlayButtonStyle: 'FILLED',
    widgetFixedThumbnail: false,
    widgetFixedThumbnailWidth: 200,
    widgetFixedThumbnailHeight: 300,
    widgetIsFixedCircle: false,
    widgetHideCompareAtPrice: false,
    widgetHideDesktop: false,
    mobileVideos: 2,
    widgetMobileChevrons: false,
    widgetNoMaxThumbnailWidth: false,
    widgetMaxThumbnailWidth: 400,
    widgetSearchBorderRadius: 'SOFT',
    widgetSearchUseName: true,
    widgetSearchThumbnailSize: 'MEDIUM',
    widgetSearchOverlayBackgroundColor: '#FFFFFF',
    widgetSearchShowSearchBar: true,
    widgetSearchSearchVideoNames: false,
    widgetSearchShowPopular: false,
    widgetSearchPopularText: 'Popular',
    widgetSearchPopularButtonColor: '#9F1F1F',
    widgetSearchPopularTextColor: '#FFFFFF',
    widgetSearchGridOffset: false,
    widgetSearchSearchableContent: 'VIDEOS',
    widgetShowProgressBar: true,
    widgetShareButton: true,
    widgetPlayButtonSize: 'MEDIUM'
  }
]

export const templateVideos = [
  {
    id: 'jbnud6w6OKqzPqQz01E018zhnSYtLAc3uDtJfydDJberw',
    uploadId: null,
    playbackId: 'jm02OSouJjysoj6jFJP5Bwftvxd00SFTVDeHyzuSrSr2A',
    createdAt: '2025-01-15T11:49:37.379Z',
    organisationId: 1133,
    name: 'Lisbon 2.mp4',
    duration: 11.9,
    aspectRatio: '9:16',
    maxStoredResolution: 'UHD',
    maxStoredFrameRate: '60',
    mp4Support: 'standard',
    aspectRatioCalc: 0.5625,
    deleted: false,
    thumbnailTime: 0,
    customThumbnail: null,
    customMobileThumbnail: null,
    tags: null,
    clipAssetId: 'eS7H3a02N6Qg65niijTg41fF34Ar1kkalsRuZdliH2Xw',
    clipPlaybackId: 'E31imXEKHG9KR19CKflDsX021NscoVCQ02Vz3XqicT006A',
    instagramId: null,
    maxHeight: 3840,
    tagsArray: null,
    rank: 0,
    random: 0,
    masterAccessUrl: null,
    masterAccessTimestamp: null,
    unpublished: false,
    campaignId: 10169,
    campaignVideoId: 1785946,
    type: 'VIDEO'
  },
  {
    id: 'r029VyfccCRDdC601O01Ek7JYVCezT02xVTkt3187xOoQb8',
    uploadId: null,
    playbackId: 'jm02OSouJjysoj6jFJP5Bwftvxd00SFTVDeHyzuSrSr2A',
    createdAt: '2025-01-15T11:49:37.379Z',
    organisationId: 1133,
    name: 'Lisbon 2.mp4',
    duration: 11.9,
    aspectRatio: '9:16',
    maxStoredResolution: 'UHD',
    maxStoredFrameRate: '60',
    mp4Support: 'standard',
    aspectRatioCalc: 0.5625,
    deleted: false,
    thumbnailTime: 0,
    customThumbnail: null,
    customMobileThumbnail: null,
    tags: null,
    clipAssetId: 'eS7H3a02N6Qg65niijTg41fF34Ar1kkalsRuZdliH2Xw',
    clipPlaybackId: 'E31imXEKHG9KR19CKflDsX021NscoVCQ02Vz3XqicT006A',
    instagramId: null,
    maxHeight: 3840,
    tagsArray: null,
    rank: 0,
    random: 0,
    masterAccessUrl: null,
    masterAccessTimestamp: null,
    unpublished: false,
    campaignId: 10169,
    campaignVideoId: 1785946,
    type: 'VIDEO'
  },
  {
    id: 'xNsUyg01UC5zD9fYfy1HxO8IWMOpeE959ZibgpGWsJmY',
    uploadId: 'sTR02cxz1GgwHuh3vzRw00o8dcbU31ILRYAAxVJMgK8D00',
    playbackId: 'jm02OSouJjysoj6jFJP5Bwftvxd00SFTVDeHyzuSrSr2A',
    createdAt: '2025-01-15T11:49:37.379Z',
    organisationId: 1133,
    name: 'Lisbon 2.mp4',
    duration: 11.9,
    aspectRatio: '9:16',
    maxStoredResolution: 'UHD',
    maxStoredFrameRate: '60',
    mp4Support: 'standard',
    aspectRatioCalc: 0.5625,
    deleted: false,
    thumbnailTime: 0,
    customThumbnail: null,
    customMobileThumbnail: null,
    tags: null,
    clipAssetId: 'eS7H3a02N6Qg65niijTg41fF34Ar1kkalsRuZdliH2Xw',
    clipPlaybackId: 'E31imXEKHG9KR19CKflDsX021NscoVCQ02Vz3XqicT006A',
    instagramId: null,
    maxHeight: 3840,
    tagsArray: null,
    rank: 0,
    random: 0,
    masterAccessUrl: null,
    masterAccessTimestamp: null,
    unpublished: false,
    campaignId: 10169,
    campaignVideoId: 1785946,
    type: 'VIDEO'
  },
  {
    id: '7vTvdKPWw4q4oRViY9djmo2i01HD2Tf4f2n3huaKHIUY',
    uploadId: 'vbbTEl4tcA2b7Dh00TM01UJl4bdUGy9h01rMVoXDNCfmDU',
    playbackId: 'jm02OSouJjysoj6jFJP5Bwftvxd00SFTVDeHyzuSrSr2A',
    createdAt: '2025-01-15T11:49:37.379Z',
    organisationId: 1133,
    name: 'Lisbon 2.mp4',
    duration: 11.9,
    aspectRatio: '9:16',
    maxStoredResolution: 'UHD',
    maxStoredFrameRate: '60',
    mp4Support: 'standard',
    aspectRatioCalc: 0.5625,
    deleted: false,
    thumbnailTime: 0,
    customThumbnail: null,
    customMobileThumbnail: null,
    tags: null,
    clipAssetId: 'eS7H3a02N6Qg65niijTg41fF34Ar1kkalsRuZdliH2Xw',
    clipPlaybackId: 'E31imXEKHG9KR19CKflDsX021NscoVCQ02Vz3XqicT006A',
    instagramId: null,
    maxHeight: 3840,
    tagsArray: null,
    rank: 0,
    random: 0,
    masterAccessUrl: null,
    masterAccessTimestamp: null,
    unpublished: false,
    campaignId: 10169,
    campaignVideoId: 1785946,
    type: 'VIDEO'
  },
  {
    id: 'SaBDLjL2ugFWbZUVSLmRCgWLexluZ8UN6tzex4J9pLo',
    uploadId: 'M5aSgdZ1Qwkk1HiD00PI3OTVp1QuhxXI01jUYWRHxYbSE',
    playbackId: 'jm02OSouJjysoj6jFJP5Bwftvxd00SFTVDeHyzuSrSr2A',
    createdAt: '2025-01-15T11:49:37.379Z',
    organisationId: 1133,
    name: 'Lisbon 2.mp4',
    duration: 11.9,
    aspectRatio: '9:16',
    maxStoredResolution: 'UHD',
    maxStoredFrameRate: '60',
    mp4Support: 'standard',
    aspectRatioCalc: 0.5625,
    deleted: false,
    thumbnailTime: 0,
    customThumbnail: null,
    customMobileThumbnail: null,
    tags: null,
    clipAssetId: 'eS7H3a02N6Qg65niijTg41fF34Ar1kkalsRuZdliH2Xw',
    clipPlaybackId: 'E31imXEKHG9KR19CKflDsX021NscoVCQ02Vz3XqicT006A',
    instagramId: null,
    maxHeight: 3840,
    tagsArray: null,
    rank: 0,
    random: 0,
    masterAccessUrl: null,
    masterAccessTimestamp: null,
    unpublished: false,
    campaignId: 10169,
    campaignVideoId: 1785946,
    type: 'VIDEO'
  },
  {
    id: 'ZMX02U1e7biis7yiEqkAx0102OoYDBiDK9oXut6MHUmDdU',
    uploadId: 'XlX4VwG7JpHyUqh5K6gvukROUU6OI4K4MSWo6Ra9MD8',
    playbackId: 'jm02OSouJjysoj6jFJP5Bwftvxd00SFTVDeHyzuSrSr2A',
    createdAt: '2025-01-15T11:49:37.379Z',
    organisationId: 1133,
    name: 'Lisbon 2.mp4',
    duration: 11.9,
    aspectRatio: '9:16',
    maxStoredResolution: 'UHD',
    maxStoredFrameRate: '60',
    mp4Support: 'standard',
    aspectRatioCalc: 0.5625,
    deleted: false,
    thumbnailTime: 0,
    customThumbnail: null,
    customMobileThumbnail: null,
    tags: null,
    clipAssetId: 'eS7H3a02N6Qg65niijTg41fF34Ar1kkalsRuZdliH2Xw',
    clipPlaybackId: 'E31imXEKHG9KR19CKflDsX021NscoVCQ02Vz3XqicT006A',
    instagramId: null,
    maxHeight: 3840,
    tagsArray: null,
    rank: 0,
    random: 0,
    masterAccessUrl: null,
    masterAccessTimestamp: null,
    unpublished: false,
    campaignId: 10169,
    campaignVideoId: 1785946,
    type: 'VIDEO'
  },
  {
    id: 'vtu6SjFicLPROdl027T6Pi6KC8NHDoKM6CO263AZRpdY',
    uploadId: 'CkIIWpuFUFxYzKmXoLHbaIyBZS01XpEhdgFWN1zbU2Ws',
    playbackId: 'jm02OSouJjysoj6jFJP5Bwftvxd00SFTVDeHyzuSrSr2A',
    createdAt: '2025-01-15T11:49:37.379Z',
    organisationId: 1133,
    name: 'Lisbon 2.mp4',
    duration: 11.9,
    aspectRatio: '9:16',
    maxStoredResolution: 'UHD',
    maxStoredFrameRate: '60',
    mp4Support: 'standard',
    aspectRatioCalc: 0.5625,
    deleted: false,
    thumbnailTime: 0,
    customThumbnail: null,
    customMobileThumbnail: null,
    tags: null,
    clipAssetId: 'eS7H3a02N6Qg65niijTg41fF34Ar1kkalsRuZdliH2Xw',
    clipPlaybackId: 'E31imXEKHG9KR19CKflDsX021NscoVCQ02Vz3XqicT006A',
    instagramId: null,
    maxHeight: 3840,
    tagsArray: null,
    rank: 0,
    random: 0,
    masterAccessUrl: null,
    masterAccessTimestamp: null,
    unpublished: false,
    campaignId: 10169,
    campaignVideoId: 1785946,
    type: 'VIDEO'
  },
  {
    id: 's01zRZn46fFl02QIApzk0001qpH8awIhe3tJ1TzA4AAlysY',
    uploadId: 'fX9KrjRWA68bwC82ACgTW92ygQx1O5cpNJLBu3F01jGA',
    playbackId: 'jm02OSouJjysoj6jFJP5Bwftvxd00SFTVDeHyzuSrSr2A',
    createdAt: '2025-01-15T11:49:37.379Z',
    organisationId: 1133,
    name: 'Lisbon 2.mp4',
    duration: 11.9,
    aspectRatio: '9:16',
    maxStoredResolution: 'UHD',
    maxStoredFrameRate: '60',
    mp4Support: 'standard',
    aspectRatioCalc: 0.5625,
    deleted: false,
    thumbnailTime: 0,
    customThumbnail: null,
    customMobileThumbnail: null,
    tags: null,
    clipAssetId: 'eS7H3a02N6Qg65niijTg41fF34Ar1kkalsRuZdliH2Xw',
    clipPlaybackId: 'E31imXEKHG9KR19CKflDsX021NscoVCQ02Vz3XqicT006A',
    instagramId: null,
    maxHeight: 3840,
    tagsArray: null,
    rank: 0,
    random: 0,
    masterAccessUrl: null,
    masterAccessTimestamp: null,
    unpublished: false,
    campaignId: 10169,
    campaignVideoId: 1785946,
    type: 'VIDEO'
  },
  {
    id: 'l01Ckd9RHE2Q9wFZbgkL7TAQ2zAtmMNedpsJqizZgc0100',
    uploadId: 'yrWjGBHggLVV5fDKTu2F016cjyQJzcktdTRISX2lfj01g',
    playbackId: 'jm02OSouJjysoj6jFJP5Bwftvxd00SFTVDeHyzuSrSr2A',
    createdAt: '2025-01-15T11:49:37.379Z',
    organisationId: 1133,
    name: 'Lisbon 2.mp4',
    duration: 11.9,
    aspectRatio: '9:16',
    maxStoredResolution: 'UHD',
    maxStoredFrameRate: '60',
    mp4Support: 'standard',
    aspectRatioCalc: 0.5625,
    deleted: false,
    thumbnailTime: 0,
    customThumbnail: null,
    customMobileThumbnail: null,
    tags: null,
    clipAssetId: 'eS7H3a02N6Qg65niijTg41fF34Ar1kkalsRuZdliH2Xw',
    clipPlaybackId: 'E31imXEKHG9KR19CKflDsX021NscoVCQ02Vz3XqicT006A',
    instagramId: null,
    maxHeight: 3840,
    tagsArray: null,
    rank: 0,
    random: 0,
    masterAccessUrl: null,
    masterAccessTimestamp: null,
    unpublished: false,
    campaignId: 10169,
    campaignVideoId: 1785946,
    type: 'VIDEO'
  }
]

export const templateTitles = {
  jbnud6w6OKqzPqQz01E018zhnSYtLAc3uDtJfydDJberw: 'Scotland',
  r029VyfccCRDdC601O01Ek7JYVCezT02xVTkt3187xOoQb8: 'Umbria',
  xNsUyg01UC5zD9fYfy1HxO8IWMOpeE959ZibgpGWsJmY: 'Lisbon',
  '7vTvdKPWw4q4oRViY9djmo2i01HD2Tf4f2n3huaKHIUY': 'Los Angeles',
  SaBDLjL2ugFWbZUVSLmRCgWLexluZ8UN6tzex4J9pLo: 'Amsterdam',
  ZMX02U1e7biis7yiEqkAx0102OoYDBiDK9oXut6MHUmDdU: 'Barcelona',
  vtu6SjFicLPROdl027T6Pi6KC8NHDoKM6CO263AZRpdY: 'London',
  s01zRZn46fFl02QIApzk0001qpH8awIhe3tJ1TzA4AAlysY: 'Paris',
  l01Ckd9RHE2Q9wFZbgkL7TAQ2zAtmMNedpsJqizZgc0100: 'Bali'
}

export const templateSubtitles = {
  jbnud6w6OKqzPqQz01E018zhnSYtLAc3uDtJfydDJberw: 'USA',
  r029VyfccCRDdC601O01Ek7JYVCezT02xVTkt3187xOoQb8: 'Italy',
  xNsUyg01UC5zD9fYfy1HxO8IWMOpeE959ZibgpGWsJmY: 'Portugal',
  '7vTvdKPWw4q4oRViY9djmo2i01HD2Tf4f2n3huaKHIUY': 'USA',
  SaBDLjL2ugFWbZUVSLmRCgWLexluZ8UN6tzex4J9pLo: 'Netherlands',
  ZMX02U1e7biis7yiEqkAx0102OoYDBiDK9oXut6MHUmDdU: 'Spain',
  vtu6SjFicLPROdl027T6Pi6KC8NHDoKM6CO263AZRpdY: 'UK',
  s01zRZn46fFl02QIApzk0001qpH8awIhe3tJ1TzA4AAlysY: 'France',
  l01Ckd9RHE2Q9wFZbgkL7TAQ2zAtmMNedpsJqizZgc0100: 'Indonesia'
}

export const templateVideoObjects = templateVideos.map((video, index) => ({
  id: 200000 + index,
  campaignVideoId: video.campaignVideoId,
  buttonLink: null,
  buttonText: null,
  type: 'TITLE',
  deleted: false,
  campaignId: video.campaignId,
  videoId: video.id,
  //   title: templateTitles[video.id],
  // subtitle: templateSubtitles[video.id]
  title: 'Title',
  subtitle: 'Subtitle'
}))
